import { HTMLAttributes } from 'react';
import { BsArrowReturnLeft } from 'react-icons/bs';
import { PaymentIncentiveContainer } from './styles/payment-incentive';
import { useTheme } from 'styled-components';

export const PaymentIncentiveCard: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
	const theme = useTheme();

	return (
		<PaymentIncentiveContainer>
			<BsArrowReturnLeft size={50} style={{ transform: 'rotate(-90deg)', marginBottom: '1rem' }} color="#000" />
			<h3 style={{ fontWeight: '700' }}>Start Saving Money</h3>
			<p className="text-center" style={{ lineHeight: '2rem' }}>
				With Talents Arena direct hiring services{' '}
				<span style={{ color: theme.TA_GREEN, fontWeight: 500 }}>you save more 70% of the hiring costs.</span>{' '}
				Interview candidates as fast as 48 hrs
			</p>
		</PaymentIncentiveContainer>
	);
};
